import {useQuery} from '@tanstack/react-query';
import { authorizedGet } from '../functions/AuthService';

export const useJobtrackMachineRecord = () => {
    return useQuery({
        queryKey: ['machine', 'jobtrack'],
        queryFn: async () => {
            const response = await authorizedGet("/jobtrack/getmachinerecord");
            // console.log("Response: ", response.body.json());
            return await response.body.json();
        },
        staleTime: 1000 * 60 * 5, //5 minutes
        gcTime: 1000 * 60 * 15, //Keep it in memory for 15 minutes
        refetchOnWindowFocus: false //Prevent refresh if the tab is clicked
    });
}
